<script setup></script>

<template>
    <div class="text-2x font-semibold">
        Sorry this item is currently unavailable for configuration.
    </div>
</template>
